/**
 * suē staging-only gallery. Never modifies Shopify product media or native purchase inputs.
 * Uses delegated handlers so Horizon may morph the featured-product-information node.
 */
(function () {
  if (window.__sueBuyGalleryInstalled) return;
  window.__sueBuyGalleryInstalled = true;

  function sync(gallery, shade, index) {
    if (!gallery) return;
    const safeShade = shade === 'sand' ? 'sand' : 'charcoal';
    const safeIndex = Math.max(0, Math.min(4, Number(index) || 0));
    gallery.dataset.shade = safeShade;
    gallery.dataset.activeIndex = String(safeIndex);
    gallery.querySelectorAll('[data-buy-shade]').forEach(function(el) {
      const sameShade = el.dataset.buyShade === safeShade;
      const isThumb = el.hasAttribute('data-buy-thumb');
      const active = sameShade && (isThumb || Number(el.dataset.buyIndex) === safeIndex);
      el.hidden = !active;
      if (isThumb) el.setAttribute('aria-pressed', String(Number(el.dataset.buyIndex) === safeIndex));
    });
  }

  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-buy-thumb]');
    if (!button) return;
    const gallery = button.closest('[data-sue-buy-gallery]');
    sync(gallery, button.dataset.buyShade, button.dataset.buyIndex);
  });

  document.addEventListener('change', function(event) {
    const picker = event.target.closest('variant-picker');
    if (!picker) return;
    const field = event.target;
    const optionName = field.dataset.optionName || field.selectedOptions?.[0]?.dataset.optionName || '';
    if (optionName.toLowerCase() !== 'color') return;
    const area = picker.closest('featured-product-information, product-information') || picker.closest('.shopify-section');
    const gallery = area?.querySelector('[data-sue-buy-gallery]') || document.querySelector('[data-sue-buy-gallery]');
    sync(gallery, String(field.value).trim().toLowerCase(), 0);
  });
})();